<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageaddheader :title="title" :title1="title1" :items="items"/>
        <f-table
            :data="data"
            :columns="columns"
            :filters="filters"
            :paginationConfig="pagination"
            @pageChange="({ page }) => getSalesReturn(page)"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'product'">
              <div class="productimgname">
                <a href="javascript:void(0);" class="product-img">
                  <img :src="record.product.image" alt="product"/>
                </a>
                <a :href="'products/' + record.product.id">{{
                    record.product.name
                  }}</a>
              </div>
            </template>

            <template v-else-if="column.key === 'Status'">
              <span
                  class="badges bg-lightgreen"
                  v-if="record.Status === 'Processed'"
              >
                {{ record.Status }}
              </span>
              <span
                  class="badges bg-lightyellow"
                  v-else-if="record.Status === 'Pending'"
              >
                {{ record.Status }}
              </span>
              <span class="badges bg-lightred" v-else>
                {{ record.Status }}
              </span>
            </template>

            <template v-else-if="column.key === 'pay'">
              <span
                  class="badges bg-lightgreen"
                  v-if="record.PaymentStatus === 'Approved'"
              >
                {{ record.PaymentStatus }}
              </span>
              <span class="badges bg-lightred" v-else>
                {{ record.PaymentStatus }}
              </span>
            </template>

            <template v-else-if="column.key === 'reference'">
              <router-link
                  title="Click to View Order"
                  :to="'orders/' + record.order_id"
              >
                {{ record.reference }}
              </router-link>
            </template>

            <template v-else-if="column.key === 'action'">
              <div
                  v-if="record.Status !== 'Processed'"
                  style="display: flex; align-items: center; gap: 8px"
              >
                <span
                    v-if="hasAccess('.*approve-sales-return.*')"
                    @click="approveSalesReturn(record.id)"
                    style="
                    background-color: #28c76f;
                    color: white;
                    padding: 6px 14px;
                    border-radius: 5px;
                    font-size: 14px;
                    cursor: pointer;
                    display: inline-block;
                    transition: background-color 0.3s ease;
                  "
                >
                  Process
                </span>

                <span
                    class="confirm-text"
                    @click="deleteSalesReturn(record.id)"
                    style="cursor: pointer; flex-shrink: 0"
                    title="Delete"
                >
                  <img
                      src="../../../assets/img/icons/delete.svg"
                      alt="Delete"
                      style="
                      width: 27px;
                      height: 27px;
                      transition: transform 0.2s ease;
                    "
                      @mouseover="
                      (e) => (e.target.style.transform = 'scale(1.2)')
                    "
                      @mouseleave="(e) => (e.target.style.transform = 'scale(1)')"
                  />
                </span>
              </div>
            </template>
          </template>
        </f-table>
      </div>
    </div>
  </div>
</template>
<script>
import {ref} from "vue";
import {mapActions, mapGetters} from "vuex";

const currentDate = ref(new Date());
const columns = [
  {
    sorter: true,
  },
  {
    title: "Order Reference",
    dataIndex: "reference",
    key: "reference",
    sorter: {
      compare: (a, b) => {
        a = a.reference.toLowerCase();
        b = b.reference.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Customer",
    dataIndex: "customer_name",
    sorter: {
      compare: (a, b) => {
        a = a.customer_name.toLowerCase();
        b = b.customer_name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Product Name",
    key: "product",
    sorter: {
      compare: (a, b) => {
        a = a.name.toLowerCase();
        b = b.name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Returned Quantity",
    dataIndex: "Quantity",
    key: "Quantity",
    sorter: {
      compare: (a, b) => {
        a = a.Quantity.toLowerCase();
        b = b.Quantity.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Date",
    dataIndex: "Date",
    sorter: (a, b) => a.Date.localeCompare(b.Date),
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        a = a.Status.toLowerCase();
        b = b.Status.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Total",
    dataIndex: "Total",
    sorter: {
      compare: (a, b) => {
        a = a.Total.toLowerCase();
        b = b.Total.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

export default {
  data() {
    return {
      filters: ["customer_name", "reference", "product_name"],
      title: "Sales Return List",
      title1: "Manage your Returns",
      items: [
        {
          text: "Add New Sales Return",
          addname: "/createsalesreturn",
        },
        // {
        //   text: "Add New Sales Return",
        //   addname: "/createsalesreturn",
        // },
      ],
      data: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        per_page: 11,
      },
      columns,
      startdate: currentDate,
      Choose: ["Choose Customer", "Customer["],
      Status: ["Choose Status", "Inprogress"],
      Payment: ["Choose Payment Status", "Payment Status"],
    };
  },
  computed: {
    ...mapGetters(["formatAmount", "hasAccess"]),
  },
  methods: {
    ...mapActions({
      _getSalesReturn: "saleReturn/get",
      _approveSalesReturn: "saleReturn/approve",
      _deleteSalesReturn: "saleReturn/delete",
    }),
    deleteSalesReturn(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning", // adds the warning icon
        showCancelButton: true,
        confirmButtonColor: "#FF9F43",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          this._deleteSalesReturn({id: id})
              .then(() => {
                Swal.fire({
                  title: "Deleted!",
                  text: "Sales return has been deleted.",
                  icon: "success",
                });
                this.getSalesReturn();
              })
              .catch((error) => {
                const errorMessage =
                    error?.response?.data?.message ||
                    "An unexpected error occurred.";
                Swal.fire({
                  title: "Error!",
                  text: errorMessage,
                  icon: "error",
                });
              });
        }
      });
    },
    async getSalesReturn(page = 1) {
      try {
        const response = await this._getSalesReturn({
          per_page: 10,
          page: page
        });
        this.data = response.data.data.map((sale_return) => ({
          id: sale_return.id,
          Quantity: sale_return.qty,
          Date: sale_return.date,
          customer_name: sale_return.user.name,
          reference: sale_return.order.reference,
          order_id: sale_return.order.id,
          Status: sale_return.status,
          Total: this.formatAmount(sale_return.total),
          product: sale_return.product,
          product_name: sale_return.product.name,
        }));

        // Store pagination meta from API response
        this.pagination = response.data.pagination;
      } catch (error) {
        console.error("Failed to fetch sales returns:", error);
        Swal.fire({
          title: "Error fetching sales returns",
          text: error.message,
          icon: "error",
        });
      }
    },
    async approveSalesReturn(id) {
      try {
        await this._approveSalesReturn({sales_return_product_id: id});
        Swal.fire({
          title: "Sale Return Approved",
          icon: "success",
        });
        await this.getSalesReturn(this.pagination.currentPage); // refresh the list after approval
      } catch (error) {
        Swal.fire({
          title: error.response?.data?.message || "Failed to approve",
          icon: "error",
        });
      }
    },

    async onPageChange(page) {
      await this.getSalesReturn(page);
    },
  },
  mounted() {
    this.getSalesReturn();
  },
  name: "salesreturnlist",
};
</script>
